import { config } from '../../../config';
import { fetchWithAuth } from '../fetchWithAuth';

const base = () => `${config().catalogueServiceBaseUrl}/back-office/campaigns`;

async function request(path, options = {}) {
    const res = await fetchWithAuth(`${base()}${path}`, options);
    if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body.error || res.statusText);
    }
    return res.json();
}

const json = (method, body) => ({
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
});

export const campaignsApi = {
    list: () => request('/').then((res) => res.campaigns),
    get: (id) => request(`/${id}`),
    create: (input) => request('/', json('POST', input)),
    update: (id, input) => request(`/${id}`, json('PUT', input)),
    remove: (id) => request(`/${id}`, { method: 'DELETE' }),
    /** Delivers the campaign's dialog as an inbox notification to the given users (the way to test on a real device). */
    send: (id, input) => request(`/${id}/send`, json('POST', input)),
    /** The public pack list, for the sale card's per-pack store product rows. */
    packs: async () => {
        const res = await fetch(`${config().catalogueServiceBaseUrl}/credits/packs`);
        if (!res.ok) throw new Error(res.statusText);
        return res.json();
    },
};
